export default __webpack_public_path__ + "static/media/Seguimiento_3.24dd9791.svg";